import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=73721f2a&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"
import style0 from "./Resources.vue?vue&type=style&index=0&id=73721f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73721f2a",
  null
  
)

export default component.exports